module.exports = __webpack_public_path__ + "static/media/heart11.0ae60565.svg";